import { ReactComponent as ShirtIcon } from "../../svgs/jersey.svg";
import styles from "./index.module.scss";

export const teamColors = {
  "6992": ["rgb(18,38,66)", "#fff"],
  "21903": ["rgb(249,221,75)", "#000"],
  "86209": ["rgb(226,202,78)", "rgb(52, 129, 0)"],
  "49364": ["rgb(151,40,40)", "rgb(253, 236, 0)"],
  "67939": ["rgb(20,65,173)", "#fff"],
  "83678": ["rgb(236,208,92)", "rgb(24,66,104)"],
  "2740": ["#fff", "rgb(56,120,67)"],
  "53629": ["rgb(20,35,66)", "rgb(239,177,100)"],
  "53645": ["rgb(47,109,72)", "#fff"],
  "65423": ["rgb(23,22,26)", "rgb(223,193,168	)"],
  "30697": ["#fff", "rgb(65,110,168)"],
  "2712": ["rgb(88,149,79)", "#fff"],
  "110586": ["rgb(39,39,39)", "#fff"],
  "61761": ["rgb(159,49,47)", "#fff"],
  "111182": ["rgb(199,60,59)", "#fff"],
  "81169": ["rgb(37,36,38)", "rgb(221,185,64)"],
  "18303": ["rgb(248,206,76)", "#000"],
  "81401": ["rgb(215,84,145)", "rgb(246,196,81)"],
  "27227": ["rgb(129, 255, 179)", "rgb(193,55,39)"],
  "112110": ["rgb(101, 219, 181)", "rgb(29,27,28)"],
  "119780": ["rgb(212,239,78)", "rgb(51,54,35)"],
  "120839": ["rgb(39,102,197)", "#fff"],
};

const Shirt = ({ age, number, teamId, showAge = true, isSmall = false }) => {
  const tc = teamColors[teamId];

  if (!tc?.length) return null;

  return (
    <div className={styles.view}>
      <div className={styles.shirtCnt}>
        <ShirtIcon
          style={{
            fill: tc[0],
            width: isSmall ? 35 : 50,
            transform: `scale(${isSmall ? 0.95 : 1.2})`,
          }}
          className={styles.icon}
        />
        <div
          style={{ color: tc[1], fontSize: `${isSmall ? "1rem" : "1.4rem"}` }}
          className={styles.number}
        >
          {number}
        </div>
      </div>
      {showAge && <div className={styles.age}>ВІК {age}</div>}
    </div>
  );
};

export default Shirt;
